import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import RouteAdminFeaturesUserShowQuery from 'routes/admin/features/user.query'

const TOGGLE_FEATURE_FOR_USER = gql`
  mutation ToggleFeatureForUserMutation($input: ToggleFeatureForUserInput!) {
    toggleFeatureForUser(input: $input) {
      user {
        id
        features
      }
    }
  }
`

const ToggleFeatureForUserMutation = ({ children, user }) => (
  <Mutation mutation={TOGGLE_FEATURE_FOR_USER}>
    {(mutation, props) =>
      children({
        ...props,
        toggleFeatureForUser: attrs =>
          mutation({
            variables: {
              input: { userId: user.id, ...attrs }
            },
            optimisticResponse: {
              toggleFeatureForUser: {
                __typename: 'ToggleFeatureForUserPayload',
                user: {
                  id: user.id,
                  features: attrs.enabled
                    ? [...user.features, attrs.name]
                    : user.features.filter(name => name !== attrs.name),
                  __typename: 'User'
                }
              }
            },

            update: (
              cache,
              {
                data: {
                  toggleFeatureForUser: { user }
                }
              }
            ) => {
              cache.writeQuery({
                query: RouteAdminFeaturesUserShowQuery,
                data: { user }
              })
            }
          })
      })
    }
  </Mutation>
)

export default ToggleFeatureForUserMutation



// WEBPACK FOOTER //
// ./src/components/mutations/ToggleFeatureForUser.js